/**
 * Возвращает функцию, которая не будет срабатывать, пока продолжает вызываться.
 * Она сработает только один раз через N миллисекунд после последнего вызова.
 * Если ей передан аргумент `immediate`, то она будет вызвана один раз сразу после
 * первого запуска.
 * @param {function} fn - Функция которая выполнится через указанное время
 * @param {number} delay - указанное время
 * @return {function}

 */

export const debounce = (fn, delay = 500) => {
  function debounced(...args) {
    clearTimeout(debounced.timer);
    debounced.timer = setTimeout(() => {
      fn(...args);
    }, delay);
  }
  debounced.timer = null;
  return debounced;
};

/**
 * Преобразщовывает дату в строку без учета timezone
 * @param {Date} date - Дата
 * @return {string}

 */
export const dateToString = (date) => {
  const Year = `${'0000'.slice(0, 4 - date.getFullYear().toString().length)}${date.getFullYear()}`;
  return `${Year}-${date.getMonth() + 1}-${date.getDate()}`;
};

/**
 * Устанавливаент свойство displayName для компонента, обернутого в HOC
 * @param WrappedComponent
 * @return {*|string}
 */
export const getDisplayName = (WrappedComponent) => (
  WrappedComponent.displayName || WrappedComponent.name || WrappedComponent.type || 'Component'
);

/**
 * Дополняеть строку указанным символом слева
 * @param str {string}
 * @param symbol {string}
 * @param length {int}
 * @return {string}
 */
export const padl = (str = '', symbol = '0', length = 10) => symbol.repeat(length).concat(str).slice(-length);

export const downloadFileFromJSON = (jsonData, filename) => {
  const a = document.createElement('a');
  a.href = jsonData;
  a.download = filename;
  const child = document.body.appendChild(a);
  a.click();
  document.body.removeChild(child);
};

export function getRandomID(min = 0, max = Number.MAX_SAFE_INTEGER) {
  const int = Math.floor(Math.random() * (max - min + 1)) + min;
  return int.toString(36);
}

/**
 * Функция ползволяет заворачивать в base64 кирилицу
 * см. https://developer.mozilla.org/en-US/docs/Web/API/btoa
 * @param string
 * @return {string}
 */
export function toBinary(string) {
  const codeUnits = Uint16Array.from(
    { length: string.length },
    (element, index) => string.charCodeAt(index),
  );
  const charCodes = new Uint8Array(codeUnits.buffer);

  let result = '';
  charCodes.forEach((char) => {
    result += String.fromCharCode(char);
  });
  return result;
}

export function readFileAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = () => {
      reject(reader.error);
    };
    reader.readAsDataURL(file);
  });
}
